import ndsTokens from 'nicollet-tokens';
import styled from 'styled-components';
import { ndsFormStyles, ndsBoxSizing, ndsFontReset } from '@nicollet/common';

const localStyles = {
  width: {
    rightContent: '60px' // Only applies to the right content behavior of <Input>

  }
}; // Moves label above form field when focused or has input

const hasInputStyles = `
  label {
    font-size: ${ndsTokens.font.size.text.small};
    transform: translate3d(0, -8px, 0);
    /* Visual spacing when the label is raised up */
    padding-left: ${ndsTokens.space.generic.x1};
    padding-right: ${ndsTokens.space.generic.x1};
  }
`;
const invalidStyles = `
  input {
    border-color: ${ndsFormStyles.colors.alert.warning.border};
    background-color: ${ndsFormStyles.colors.alert.warning.background};
  }

  textarea {
    background-color: ${ndsFormStyles.colors.alert.warning.background};
    border-color: ${ndsFormStyles.colors.alert.warning.border};
  }
`;
const disabledStyles = `
  cursor: not-allowed;

  input,
  textarea {
    background: ${ndsFormStyles.colors.background.disabled};
    color: ${ndsFormStyles.colors.text.disabled};
    cursor: not-allowed;
    border: 1px solid ${ndsTokens.colors.interactive.disabled.default};
  }
`;
const InputWrapper = styled.div`
  ${ndsBoxSizing}
  ${ndsFontReset()}
  line-height: 0;
  position: relative;
  z-index: 0; /* contain nested z-index (requires non-static position) */

  input,
  textarea {
    position: relative;
    background: ${ndsTokens.colors.background.default};
    font-size: ${ndsTokens.font.size.input.base};
    line-height: ${ndsTokens.font.lineHeight.text};
    resize: none;
    outline: none;
    padding: ${props => props.rightContent ? `9px calc(${localStyles.width.rightContent} + ${ndsTokens.space.generic.x2} + 6px) 9px ${ndsTokens.space.generic.x2}` : `9px ${ndsTokens.space.generic.x2}`};
    ${({
  hasFocus
}) => hasFocus && `padding-left: calc(${ndsTokens.space.generic.x2} - 1px);`}

    /* the current left padding is set based on the width of the flag icon, however if other use cases were to arise, this would need to change based on the width of whatever was being set to left content */
    padding-left: ${props => props.leftContent ? '50px' : ''};
    margin: 0;

    /* stylelint-disable-next-line property-no-vendor-prefix */
    -webkit-appearance: none;
    border-radius: 0;
    width: 100%;
    box-shadow: none;
    box-sizing: border-box;
    border: ${props => props.hasFocus ? `2px solid ${ndsTokens.colors.border.control.input}` : `1px solid ${ndsTokens.colors.border.control.input}`};
    &::placeholder {
      color: ${ndsTokens.colors.text.onLight.primary};
    }
  }
  input {
    height: 44px;
  }

  /* Adjust size of label if rightContent is being used within the input */
  label {
    max-width: ${props => props.rightContent ? `calc(100% - ${ndsTokens.space.generic.x2} - ${ndsTokens.space.generic.x2} - ${localStyles.width.rightContent} - 6px) ` : `calc(100% - ${ndsTokens.space.generic.x2} - 1px) `};
  }

  /* Explictly check for false, and apply errorStyles, don't apply error styles if valid is undefined */
  ${props => props.valid === false && invalidStyles};
  ${props => props.hasInput && hasInputStyles};
  ${props => props.disabled && disabledStyles};
`;

export { InputWrapper };
